module.exports = __webpack_public_path__ + "img/customer.b34cffb5.svg";